// Route guard: renders children only when authenticated, otherwise the Login page.
// Single-user dashboard, so there is no deep-link preservation — any route resolves to
// either the app shell or the sign-in form.

import type { ReactNode } from "react";

import { Login } from "../pages/Login";
import { useAuth } from "./useAuth";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <section>
        <p>Loading…</p>
      </section>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return <>{children}</>;
}
